export const routes: {
  home: '/';
  error: '/error';
  missions: '/missions';
  mint: '/mint';
} = {
  home: '/',
  error: '/error',
  missions: '/missions',
  mint: '/mint',
};
